import { ref, onMounted } from "vue";
import { i as isServer } from "../utils/ssr.js";
const useClientOnly = (cb) => {
  if (isServer()) {
    const result = ref(null);
    onMounted(() => {
      result.value = cb();
    });
    return result;
  }
  return ref(cb());
};
export { useClientOnly as u };
//# sourceMappingURL=useClientOnly.js.map
